<template>
  <div class="situation-icon">
    <stopwatch
      v-if="situation.includes('imminent')"
      :id="`situation-imminent-icon${cardId}`"
      :color="getColorBySituation(situation)"
    />
    <span
      v-else
      :id="`situation-icon${cardId}`"
      :class="getItemClass(situation)"
    />
    <b-tooltip
      v-if="renderTooltip"
      placement="right"
      boundary="viewport"
      :target="`situation-imminent-icon${cardId}`"
    >
      {{ $t('messages.MI037.message', { parameter: parameter }) }}
    </b-tooltip>
  </div>
</template>
<script>
import { CoolingEfficiencySituations } from 'sigma-mappings';
import Stopwatch from '@/components/icon/Stopwatch';
import themeService from '@/services/themeService';

export default {
  name: 'CoolingEfficiencyCardIcon',
  props: {
    situation: {
      type: String,
      required: true,
    },
    parameter: {
      type: String,
      default: '',
    },
    showTooltip: {
      type: Boolean,
      default: true,
    },
    cardId: {
      type: [Number, String],
    },
  },
  components: {
    Stopwatch,
  },
  computed: {
    renderTooltip() {
      return this.showTooltip && this.situation.includes('imminent');
    },
  },
  methods: {
    getColorBySituation(situation) {
      const colorsBySituations = {
        [CoolingEfficiencySituations.VERY_HIGH_ALARM_ACTUATED]: themeService.getStyleVar('color-danger-light'),
        [CoolingEfficiencySituations.VERY_HIGH_ALARM_IMMINENT]: themeService.getStyleVar('color-danger-light'),
        [CoolingEfficiencySituations.HIGH_ALARM_ACTUATED]: themeService.getStyleVar('color-warning'),
        [CoolingEfficiencySituations.HIGH_ALARM_IMMINENT]: themeService.getStyleVar('color-warning'),
      };
      return colorsBySituations[situation];
    },
    getItemClass(situation) {
      const highAlarmIcon = 'fas fa-exclamation-triangle high-alarm-icon';
      const veryHighAlarmIcon = 'fas fa-exclamation-triangle very-high-alarm-icon';
      const icons = {
        [CoolingEfficiencySituations.VERY_HIGH_ALARM_ACTUATED]: veryHighAlarmIcon,
        [CoolingEfficiencySituations.VERY_HIGH_ALARM_IMMINENT]: veryHighAlarmIcon,
        [CoolingEfficiencySituations.HIGH_ALARM_ACTUATED]: highAlarmIcon,
        [CoolingEfficiencySituations.HIGH_ALARM_IMMINENT]: highAlarmIcon,
        [CoolingEfficiencySituations.NORMAL]: '',
      };
      return icons[situation];
    },
  },
};
</script>
<style lang="sass" scoped>
.situation-icon
  .fas
    font-size: 1.4em

  svg
    width: 2em
    height: 2em

  .very-high-alarm-icon
    color: var(--color-danger)

  .high-alarm-icon
    color: var(--color-warning)
</style>
